import React, { ReactNode, useCallback, useRef, useState } from 'react'

import './styles.scss'

type Props = {
  children: ReactNode
}

const CarouselGroup = ({ children }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isDragging, setIsDragging] = useState(false)
  const [startX, setStartX] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)

  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    if (!containerRef.current) return
    setIsDragging(true)
    setStartX(e.pageX - containerRef.current.offsetLeft)
    setScrollLeft(containerRef.current.scrollLeft)
  }, [])

  const handleMouseMove = useCallback(
    (e: React.MouseEvent) => {
      if (!isDragging || !containerRef.current) return
      e.preventDefault()
      const x = e.pageX - containerRef.current.offsetLeft
      const walk = (x - startX) * 1.5 // Multiplier for smooth scrolling
      containerRef.current.scrollLeft = scrollLeft - walk
    },
    [isDragging, scrollLeft, startX],
  )

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  return (
    <div
      className="scroll-container"
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseUp}
      onMouseUp={handleMouseUp}>
      <div ref={containerRef} className="scroll-content">
        {children}
      </div>
    </div>
  )
}

export default CarouselGroup
